import { render } from "./ItemMedia.vue?vue&type=template&id=b768bd2a&ts=true"
import script from "./ItemMedia.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemMedia.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b768bd2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b768bd2a', __exports__)) {
    api.reload('b768bd2a', __exports__)
  }
  
  module.hot.accept("./ItemMedia.vue?vue&type=template&id=b768bd2a&ts=true", () => {
    api.rerender('b768bd2a', render)
  })

}


export default __exports__